import { Stack, Button, Group } from '@mantine/core';
import React from 'react';
import { connect } from 'react-redux';

import Response from '../../components/Response';
import TestCommand from '../../components/TestCommand';
import { getApiDevice, getConfig } from '../../redux/actions/api';

const GetConfig = ({ access, getConfig }) => (
  <Stack>
    <Group>
      <Button onClick={() => getConfig(access.id)} disabled={!access.id}>
        Get
      </Button>
      <span>
        Device ID:
        {access.id || 'Not set'}
      </span>
    </Group>

    {access.id && <TestCommand url={`/${access.id}/config`} />}

    <Response type="getConfig" />
  </Stack>
);

const mapStateToProps = (state) => ({
  access: getApiDevice(state),
});

export default connect(mapStateToProps, { getConfig })(GetConfig);
